import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1AAFD0',
      gradient: 'linear-gradient(90deg, #1AAFD0 0%, #3BE8B0 100%)',
      gradientDark: 'linear-gradient(90deg, #158BA8 0%, #2DC98E 100%)',
    },
    secondary: {
      main: '#EF5734',
      gradient: 'linear-gradient(90deg, #EF5734 0%, #FFB900 100%)',
      gradientDark: 'linear-gradient(90deg, #D14828 0%, #E0A500 100%)',
    },
  },
  // Custom gradients accessible via theme.gradients
  gradients: {
    primary: 'linear-gradient(90deg, #1AAFD0 0%, #3BE8B0 100%)',
    primaryDark: 'linear-gradient(90deg, #158BA8 0%, #2DC98E 100%)',
    secondary: 'linear-gradient(90deg, #EF5734 0%, #FFB900 100%)',
    secondaryDark: 'linear-gradient(90deg, #D14828 0%, #E0A500 100%)',
  },
  typography: {
    fontSize: 13,
    fontWeightMedium: 600,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        colorPrimary: {
          background: 'linear-gradient(90deg, #1AAFD0 0%, #3BE8B0 100%)',
          transition: 'background 0.3s ease-in-out',
        },
        colorSecondary: {
          background: 'linear-gradient(90deg, #EF5734 0%, #FFB900 100%)',
          transition: 'background 0.3s ease-in-out',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          margin: '2px 8px',
          transition: 'all 0.2s ease-in-out',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(26, 175, 208, 0.12)',
            '&:hover': {
              backgroundColor: 'rgba(26, 175, 208, 0.16)',
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 36,
          color: 'rgba(0, 0, 0, 0.6)',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          fontSize: 14,
          fontWeight: 400,
        },
      },
    },
    MuiCollapse: {
      styleOverrides: {
        root: {
          '& .MuiList-root': {
            paddingTop: 4,
            paddingBottom: 4,
            backgroundColor: 'rgba(0, 0, 0, 0.02)',
            borderRadius: 8,
            margin: '0 8px 4px 8px',
          },
        },
      },
    },
  },
});

export default theme;


